module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIj48cGF0aCBmaWxsPSIjY2UxMTI2IiBkPSJNMCAwaDYwMHY0MDBIMHoiLz48cGF0aCBmaWxsPSIjMDAyODY4IiBkPSJNMCAxMDBoNjAwdjIwMEgweiIvPjxjaXJjbGUgZmlsbD0iI2ZmZiIgY3g9IjMwMCIgY3k9IjIwMCIgcj0iODAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lao.svg
// module id = R958
// module chunks = 0